import { css } from 'styled-components'
import { HEADER_HEIGHT } from '../Header/WideHeader/HeaderWrapper'
import { flexCenter } from 'src/styles/mixins'

export const ALERT_BANNER_HEIGHT = '47px'

export const AlertBannerCss = css`
  position: fixed;
  z-index: 3;
  top: ${HEADER_HEIGHT};
  height: ${ALERT_BANNER_HEIGHT};
  width: 100%;
  ${flexCenter}
`
